/**
 * Formats a number into currency
 */
const formatNumberToCurrency = () =>
  new Intl.NumberFormat('en-US', {
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'currency'
  });

/**
 * Takes an array of possible class names, filters out any undefined or empty strings and returns a
 * final className string
 */
const getFilteredClasses = (arr: Array<null | string | undefined>) => arr.filter(Boolean).join(' ');

/**
 * Takes https://example.com?param1=&param2=hello -> https://example.com?param2=hello
 */
const removeEmptyParams = (url: URL) => {
  const keysToDelete: string[] = [];
  const params = url.searchParams;

  params.forEach((value, key) => {
    if (value === '') {
      keysToDelete.push(key);
    }
  });

  keysToDelete.forEach(key => params.delete(key));

  return url;
};

export { formatNumberToCurrency, getFilteredClasses, removeEmptyParams };
